var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrganizationPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M0 0h120v120H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 24.941h70.588V95.53H24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.25 41.875V82.5h-32.5V41.875h32.5zm-23.75 12.5h4.375V50H52.5v4.375zm11.875 0h4.375V50h-4.375v4.375zM52.5 66.25h4.375v-4.375H52.5v4.375zm3.75 16.25h8.125v-8.125H56.25V82.5zm8.125-16.25h4.375v-4.375h-4.375v4.375zM40 41.875h40.625V37.5H40v4.375z",
    stroke: "#666",
    strokeWidth: 4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationPlaceholder);
export default __webpack_public_path__ + "static/media/organization-placeholder.ca9956615387f3f7bdf68d7eafd0e969.svg";
export { ForwardRef as ReactComponent };